import type Message from 'owa-service/lib/contract/Message';
import { addPopoutV2 } from 'owa-popout-v2';

interface ComposeMessage extends Message {
    groupId?: string;
}

export default function popoutMailComposeReply(isReplyAll: boolean, message: ComposeMessage) {
    addPopoutV2('mail', isReplyAll ? 'compose/replyall' : 'compose/reply', message);
}
